<template>
  <div class="text-center w-3/5 mx-auto">
    <div class="mt-16">
      <svg
        width="174"
        height="186"
        viewBox="0 0 174 186"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="86.5116" cy="99.4882" r="86.5116" fill="#E0E0E0" />
        <g clip-path="url(#clip0)">
          <path
            d="M132.998 30.0173C132.143 29.7693 131.651 28.8751 131.899 28.0201L133.453 22.6597C134.929 17.5729 131.991 12.2343 126.904 10.759C121.817 9.28363 116.478 12.2219 115.003 17.3085C114.755 18.1637 113.861 18.6557 113.006 18.4077C112.151 18.1596 111.659 17.2657 111.907 16.4104C113.877 9.61616 121.008 5.69193 127.802 7.66248C134.596 9.63303 138.52 16.7635 136.55 23.5577L134.995 28.9181C134.747 29.7734 133.853 30.2653 132.998 30.0173Z"
            fill="#FF5252"
          />
          <path
            d="M36.3804 162.642H136.643C140.271 162.642 143.212 159.701 143.212 156.073V32.0249C143.212 28.397 140.271 25.4561 136.643 25.4561H36.3804C32.7524 25.4561 29.8115 28.397 29.8115 32.0249V156.073C29.8115 159.701 32.7527 162.642 36.3804 162.642Z"
            fill="white"
          />
          <path
            d="M112.041 53.1657C106.55 51.5733 103.379 45.8108 104.972 40.3206L111.907 16.4089C112.155 15.5536 113.049 15.0616 113.904 15.3097C114.759 15.5577 115.251 16.4517 115.003 17.307L108.068 41.2185C106.971 45.0015 109.156 48.9718 112.939 50.069C116.722 51.1662 120.692 48.9811 121.789 45.1981L128.724 21.2866C129.443 18.8073 128.012 16.2056 125.532 15.4865C123.053 14.7675 120.451 16.1995 119.732 18.6786L115.451 33.4411C115.203 34.2964 114.308 34.7883 113.453 34.5403C112.598 34.2923 112.106 33.3983 112.354 32.5431L116.636 17.7805C117.85 13.5941 122.244 11.1759 126.43 12.3901C130.617 13.6043 133.035 17.9982 131.821 22.1846L124.886 46.0962C123.293 51.5866 117.531 54.7581 112.041 53.1657Z"
            fill="#FF5252"
          />
          <path
            d="M120.344 115.656H52.5592C51.2431 115.656 50.1768 114.589 50.1768 113.273C50.1768 111.957 51.2431 110.891 52.5592 110.891H120.344C121.66 110.891 122.726 111.957 122.726 113.273C122.726 114.589 121.66 115.656 120.344 115.656Z"
            fill="#FF5252"
          />
          <path
            d="M96.3143 131.3H52.5592C51.2431 131.3 50.1768 130.233 50.1768 128.918C50.1768 127.602 51.2431 126.535 52.5592 126.535H96.3143C97.6301 126.535 98.6968 127.602 98.6968 128.918C98.6968 130.233 97.6301 131.3 96.3143 131.3Z"
            fill="#404B58"
          />
          <path
            d="M106.638 146.949H52.5592C51.2431 146.949 50.1768 145.882 50.1768 144.566C50.1768 143.25 51.2431 142.184 52.5592 142.184H106.638C107.954 142.184 109.021 143.25 109.021 144.566C109.021 145.882 107.954 146.949 106.638 146.949Z"
            fill="#404B58"
          />
          <path
            d="M62.4917 82.9962C61.1757 82.9962 60.1093 81.9298 60.1093 80.6137V75.9371C60.1093 74.6211 61.1757 73.5547 62.4917 73.5547C63.8078 73.5547 64.8742 74.6211 64.8742 75.9371V80.6137C64.8742 81.9295 63.8081 82.9962 62.4917 82.9962Z"
            fill="#404B58"
          />
          <path
            d="M62.4917 82.9962C61.1757 82.9962 60.1093 81.9298 60.1093 80.6137V75.9371C60.1093 74.6211 61.1757 73.5547 62.4917 73.5547C63.8078 73.5547 64.8742 74.6211 64.8742 75.9371V80.6137C64.8742 81.9295 63.8081 82.9962 62.4917 82.9962Z"
            fill="#404B58"
          />
          <path
            d="M118.308 82.9962C116.992 82.9962 115.925 81.9298 115.925 80.6137V75.9371C115.925 74.6211 116.992 73.5547 118.308 73.5547C119.624 73.5547 120.69 74.6211 120.69 75.9371V80.6137C120.69 81.9295 119.623 82.9962 118.308 82.9962Z"
            fill="#404B58"
          />
          <circle cx="90.5003" cy="84.5" r="7.5" fill="#404B58" />
        </g>
      </svg>
    </div>
    <p class="font-normal text-2xl mt-16">
      {{ $t("message.uploadImageComponent.modals.individualError") }}
    </p>
    <p class="text-base my-10">
      {{ $t("message.uploadImageComponent.modals.pleaseWait") }}
    </p>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped></style>
